import {
    FieldWrapper,
} from "@progress/kendo-react-form";
import { Label } from "../../../../../components/layout/Label";
import { useState, useEffect } from "react";
import { toDateObject } from "../../../../../components/helpers/DateTimeHelpers";
import { DateTimePicker } from "../../../../../components/layout/date-time/DateTimePicker";

export const LocationStartStopCard = (
    {
        title,
        subTitle,
        time,
        onChange,
        hasValidationError,
        isEditable
    }) => {

    const [value, setValue] = useState(null);

    // This useEffect is not necessary but prevents a bug where date is inadvertedly set to datetime of end location
    useEffect(() => {
        setValue(toDateObject(time));
    }, [time]);

    return (
        <FieldWrapper>
            <Label hasValidationError={hasValidationError} >
                {title}:
            </Label>
            <div className="k-form-field-wrap">
                <DateTimePicker
                    disabled={!isEditable}
                    hasValidationError={hasValidationError}
                    title={subTitle}
                    value={value}
                    onChange={handleOnChange}
                />
            </div>
        </FieldWrapper>
    )

    function handleOnChange(e) {
        setValue(e);
        onChange(e);
    }
}
